export class ProjectQuery {

  public SearchQuery?: string = undefined;
  public ProjectId?: string = undefined;
  public Name?: string = undefined;
  public Description?: string = undefined;
  public ManagerUpn?: string = undefined;
  public CostCenter?: string = undefined;
  public Customer?: string = undefined;
  public InfoClass?: string = undefined;
  public Retention?: string = undefined;
  public StartDateFrom?: Date = undefined;
  public StartDateTo?: Date = undefined;
  public EndDateFrom?: Date = undefined;
  public EndDateTo?: Date = undefined;
  public ActivityStatus?: string = undefined;
  public Hierarchical?: string = undefined;
  public O365Groups?: Array<string> = undefined;
  public Limit?: number = undefined;

  constructor(opt?: Partial<ProjectQuery>) {
    Object.assign(this, opt);
  }
}
